<template>
  <div class="pro-form-img">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="drop">
        <div ref="drop_area" class="noselect" :class="seletor.class">
          <span v-show="envio === null">
            <input :id='seletor.id + "-input"' name="files[]" :disabled="seletor.disabled" :multiple="true" :value="seletor.value" type="file" @change="proFormImgOnChangeInput"/>
            <label :for='seletor.id + "-input"'><strong>Escolha um arquivo</strong><span> ou arraste-o aqui</span>.</label>
          </span>
        </div>
      </div>
      
      <div v-if="[ '', null, undefined ].indexOf(items) === -1 && items.length >= 1">
        <!-- ({{ time }}) -->
        <draggable v-model="items" :element="'div'" class="dragArea" @end="proFormImgAlterarPosicao">
          <div v-for="(item, indexF) in items" :data-id='item.id' :key='("img-" + indexF)'>
            <table>
              <tr>
                <td class="image">
                  <App-Button :cpntClass="'btn btn-danger btn-sm'" title="Clique aqui para excluir." @onClick="proFormImgRemoverArquivo(item.id)">
                    <svg class="fa fa-trash"></svg>
                  </App-Button>
      
                  <template v-if="[ '', null, undefined ].indexOf(item.thumbnail) === -1">
                    <img :src="'data:image/' + item.ext + ';base64, ' + item.thumbnail" :alt="item.filename" ref="imagem" :title="item.filename"/>
                  </template>
                  <template v-else-if="item.ext === 'pdf'">
                    <img src="/img/icones/pdf.png" :alt="item.filename" :title="item.filename"/>
                  </template>
                  <template v-else-if="item.ext === 'imagem'">
                    <img src="/img/icones/imagem.png" :alt="item.filename" :title="item.filename"/>
                  </template>
                  <template v-else-if="item.ext === 'word'">
                    <img src="/img/icones/word.png" :alt="item.filename" :title="item.filename"/>
                  </template>
                  <template v-else-if="item.ext === 'excel'">
                    <img src="/img/icones/excel.png" :alt="item.filename" :title="item.filename"/>
                  </template>
                  <template v-else-if="item.ext === 'zip'">
                    <img src="/img/icones/zip.png" :alt="item.filename" :title="item.filename"/>
                  </template>
                  <template v-else>
                    <img src="/img/icones/file.png" :alt="item.filename" :title="item.filename"/>
                  </template>
                </td>
              </tr>
              <tr v-if="indexF === 0">
                <td class="pro-form-img-principal">
                  <div>
                    Principal
                  </div>
                </td>
              </tr>
            </table>
          </div>          
        </draggable>
      </div>
    </template>

    <RF-Dialog v-if="upload !== null"
    :cpntStatus='""'
    :cpntLargura='"400px"'

    :cpntOcultarBotoes="true"
    :cpntOnFecharDialog='() => {}'>
      <template slot="conteudo">
        <div style="text-align: center;">
          <RF-Progress-Upload-Donwload
          :cpntMensagem="upload.mensagem"
          :cpntTotal="upload.total"
          :cpntTransferido="upload.transferido"
          :cpntHeight="'30px'"
          ></RF-Progress-Upload-Donwload>
        </div>
      </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>

.pro-form-img > .drop {
  padding-bottom: 5px;
  width: 100%;
  /* height: 100px; */
  margin: 0px auto;
}
  .pro-form-img > .drop > div > .titulo {
    font-size: calc(100% + 1px);
    /* font-weight: bold; */
  }
    .pro-form-img > .drop > div > .titulo > span {
      font-weight: bold;
      text-decoration: underline;
      text-transform: uppercase
    }
  .pro-form-img > .drop > .pro-form-img-box-upload {
    width: 600px;
    height: 30px;
    display: table-cell;
    vertical-align: middle;
    border-radius: 5px;

    outline: 2px dashed #92b0b3;
    outline-offset: -10px;
    -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: all 0.3s ease-in-out;

    background-color: #c8dadf;
    padding: 30px 20px;
    text-align: center;
  }
    .pro-form-img > .drop > .pro-form-img-box-upload > span > input {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }
      .pro-form-img > .drop > .pro-form-img-box-upload > span > label {
        cursor: pointer;
        color: #0f3c4b;
        font-size: var(--font-base-soma-15);
      }
      .pro-form-img > .drop > .pro-form-img-box-upload > span > input:disabled ~ label {
        cursor: no-drop;
      }
      .pro-form-img > .drop > .pro-form-img-box-upload > span > label:hover strong {
        color: #39bfd3;
        font-weight: bold;
      }
  .pro-form-img > .drop > .pro-form-img-box-upload-dragover {
    outline-offset: -20px;
    outline-color: #c8dadf;
    background-color: #f9f9f9;
  }
  .pro-form-img > .lingalleryContainer {
    text-align: center;
  }

  /* .pro-form-img > div > .dragArea {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;

    overflow-y: scroll;
    vertical-align: middle;
    color: #222;

    font-size: var(--font-base-soma-14);
    font-weight: 400;
    line-height: 20px;
  } */

  /* CSS - BARRA DE ROLAGEM DO MENU FAVORITO */
/* ----------------------------------------------------------------------- */
.pro-form-img > div > .dragArea::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  border-right: none;
}
.pro-form-img > div > .dragArea::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.pro-form-img > div > .dragArea::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: 50px;
}
.pro-form-img > div > .dragArea::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
.pro-form-img > div > .dragArea::-webkit-scrollbar-thumb:active {
  background: #ffffff;
}
.pro-form-img > div > .dragArea::-webkit-scrollbar-track {
  background: #444444;
  border: 0px none #ffffff;
  border-radius: 50px;
}
.pro-form-img > div > .dragArea::-webkit-scrollbar-track:hover {
  background: #444444;
}
.pro-form-img > div > .dragArea::-webkit-scrollbar-track:active {
  background: #444444;
}
.pro-form-img > div > .dragArea::-webkit-scrollbar-corner {
  background: transparent;
}
    /* .pro-form-img > div > .dragArea > div {
      display: inline-block;
    }
    .pro-form-img > div > .dragArea > div > div > a {
      height: 100%;
      display: inline-block;
      text-decoration: none;
      padding: 0px 6px;
      cursor: pointer;
      height: 46px;
      vertical-align: middle;
    }
      .pro-form-img > div > .dragArea > div > div > a > table {
        height: 100%;
        vertical-align: middle;
      }
        .pro-form-img > div > .dragArea > div > div > a > table > tr > td {
          color: #fff;
        }
        .pro-form-img > div > .dragArea > div > div > a > table > tr > td:first-child {
          padding: 0px 7px 0px 0px;
          margin: 0px;
        } */
  .pro-form-img > div > .dragArea > div {
    width: calc((100% / 4) - 15px);
    float: left;
    margin: 5px;
    position: relative;
    height: 100px;
  }
  .pro-form-img > div > .dragArea > div > table {
    width: 100%;
    border-collapse: separate;
    border: none;
    /* cell */
  }
    .pro-form-img > div > .dragArea > div > table > tr > td.image {
      border-radius: 5px;
      padding: 5px;
      border: 1px solid #ccc;
      text-align: center;
      vertical-align: middle;
      width: 100%;
      height: 80px;
    }
      .pro-form-img > div > .dragArea > div > table > tr > td.image > img {
        width: 67px;
      }
      .pro-form-img > div > .dragArea > div > table > tr > td.image > button {
        display: none;
        position: absolute;
        top: 2px;
        right: 2px;
      }
      .pro-form-img > div > .dragArea > div:hover > table > tr > td > button {
        display: block;
      }

      .pro-form-img > div > .dragArea > div > table > tr > td.pro-form-img-principal {
        padding: 2px;
      }
      .pro-form-img > div > .dragArea > div > table > tr > td.pro-form-img-principal > div {
        background: #e9e9e9;
        border: 1px solid #ccc;
        border-radius: 2px;
        text-align: center;
        font-weight: bold;
        height: 20px;
      }









  /* .pro-form-img > div > .dragArea > div > :not(.pro-form-img-principal) {
    border-radius: 5px;
    padding: 5px;
    border: 1px solid #ccc;
    text-align: center;
    vertical-align: middle;
    width: 100%;
    height: calc(100% - 21px);
  } 
    .pro-form-img > div > .dragArea > div > div {
      vertical-align: middle;
    }
    .pro-form-img > div > .dragArea > div > div > button {
      display: none;
      position: absolute;
      top: 2px;
      right: 2px;
    }
    .pro-form-img > div > .dragArea > div:hover > button {
      display: block;
    }

    .pro-form-img > div > .dragArea > div > div > img {
      width: 100%;
    }
    
  .pro-form-img > div > .dragArea > div > .pro-form-img-principal {
    background: #e9e9e9;
    border: 1px solid #ccc;
    border-radius: 2px;
    text-align: center;
    margin-top: -10px;
    position: relative;
    font-weight: bold;
    width: 100%;
    position: absolute;
    bottom: -2px;
    height: 21px;
  } */
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: true
      },
      cpntId: {
        required: true
      },
      cpntDados: {
        required: true
      },
      cpntEditarVarios: {
        required: true
      }
    },
    components: {
      'Armazenamento-Arquivos-Icone': () => import('@/components/armazenamento-arquivos/Armazenamento-Arquivos-Icone.vue'),
      'RF-Progress-Upload-Donwload': () => import('@/components/rf-geral/progress/RF-Progress-Upload-Donwload.vue'),
      // 'lingallery': () => import('lingallery'),
      'draggable': require('vuedraggable')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        width: 500,
        height: 200,
        items: [],
        currentId: null,
        dados: null,
        seletor: {
          id: 'app-pro-form-img',
          class: 'pro-form-img-box-upload',
          value: '',
          qrcode: '',
          disabled: false,
          onChange: this.appVenImportarOnChangeInput
        },
        arquivos: [],
        files: {},
        envio: null,
        upload: null
      }
    },
    mounted: function () {
      this.proFormImgIniciar()
    },
    methods: {
      appVenImportarSeletorObservadorIniciar: function (tentativa = 0) {
        if (tentativa <= 10) {
          setTimeout(() => {
            if ([ '', null, undefined ].indexOf(this.$refs) !== -1 || [ '', null, undefined ].indexOf(this.$refs.drop_area) !== -1) {
              this.appVenImportarSeletorObservadorIniciar((tentativa + 1))
            } else {
              var funcao = (force = false, requestId = '') => {
                if (force === true || this.seletor.requestId === requestId) {
                  // SETA A CLASSE DO CAMPO
                  this.seletor.class = [ 'pro-form-img-box-upload' ]

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  this.time = new Date().getTime()
                }
              }

              // ADICIONA O EVENTO AO COLOCAR UM ARQUIVO SOBRE O CAMPO
              $(this.$refs.drop_area).on('dragover', (event) => {
                // PARA A AÇÃO DO EVENTO
                event.stopPropagation()
                event.preventDefault()

                // SETA O REQUEST ID
                var flag = Math.floor(Math.random() * (9999 - 1000)) + 1000

                // SETA O ID GERADO
                this.seletor.requestId = flag

                // SETA A CLASSE DO CAMPO
                this.seletor.class = [ 'pro-form-img-box-upload', 'pro-form-img-box-upload-dragover' ]

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()

                // CHAMA A FUNÇÃO PARA LIMPAR O STATUS APÓS 200MS
                setTimeout(function () { funcao(false, flag) }, 200)
              })

              // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
              $(this.$refs.drop_area).on('dragenter', (event) => {
                // PARA A AÇÃO DO EVENTO
                event.stopPropagation()
                event.preventDefault()

                // CHAMA A FUNÇÃO PARA LIMPAR O STATUS
                funcao(true)
              })

              // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
              $(this.$refs.drop_area).on('drop', (event) => {
                // PARA A AÇÃO DO EVENTO
                event.stopPropagation()
                event.preventDefault()

                // // DESABILITA O INPUT PARA INSERIR NOVO
                // this.seletor.disabled = true

                // // LIMPA O STATUS PARA PARAR O PROCESSO
                // this.seletor.requestId = ''

                // // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
                // this.seletor.value = []

                // // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                // this.time = new Date().getTime()

                // // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
                // console.warn(event.originalEvent.dataTransfer.files)
                // this.proFormImgOnChangeInput(event.originalEvent.dataTransfer.files)

                // DESABILITA O INPUT PARA INSERIR NOVO
                this.seletor.status = 'carregando'

                // DESABILITA O INPUT PARA INSERIR NOVO
                this.seletor.disabled = true

                // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
                this.seletor.value = []

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()

                // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
                this.proFormImgArquivoLer(event.originalEvent.dataTransfer.files)

                // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
                this.appVenImportarVerificarStatusSeletor()
              })
            }
          }, tentativa === 0 ? 1 : 200)
        }
      },
      appVenImportarVerificarStatusSeletor: function () {
        // VERIFICA SE TEM ALGUM ARQUIVO SELECIONADO
        this.seletor.disabled = this.envio !== null
        
        // VERIFICA O STATUS DO CAMPO
        switch (this.seletor.disabled) {
          case true:
            // SETA A CLASSE DO CAMPO
            this.seletor.class = [ 'ven-imp-box-upload', 'ven-imp-box-upload-dragover' ]
            break

          case false:
            // SETA A CLASSE DO CAMPO
            this.seletor.class = [ 'ven-imp-box-upload' ]
            break
        }

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.seletor.value = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormImgIniciar: function () {
        // CHAMA A FUNÇÃO PARA SETAR O STATUS
        this.proFormImgSetarStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA BUSCAR AS IMAGENS DO PRODUTO
        this.proFormImgBuscarImagensProduto(() => {
          // INICIA OS OBSERVADORES
          this.appVenImportarSeletorObservadorIniciar()

          // SETA O STATUS DA PAGINA
          this.proFormImgSetarStatusGeral('') 
        })
      },
      proFormImgSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormImgOnChangeInput: function (event) {
        // LIMPA OS DADOS DO INPUT
        this.seletor.value = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // PEGA O ARQUIVO
        var arquivo = [ '', null, undefined ].indexOf(event.clipboardData) === -1 ? event.clipboardData : event.target

        // VERIFICA SE TEM ALGUM ARQUIVO PARA SALVAR
        if (arquivo.files.length >= 1) {
          // DESABILITA O INPUT PARA INSERIR NOVO
          this.seletor.status = 'carregando'

          // DESABILITA O INPUT PARA INSERIR NOVO
          this.seletor.disabled = true

          // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
          this.seletor.value = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // SETA A CLASSE DO CAMPO
          this.seletor.class = [ 'pro-form-img-box-upload', 'pro-form-img-box-upload-dragover' ]

          // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
          this.proFormImgArquivoLer(arquivo.files)
        }
      },
      proFormImgProgress: function (mensagem, retornos) {
        // INICIA A VARIAVEL QUE VAI RECEBER OS DADOS
        var dados = { total: 0, transferido: 0 }

        // PEGA OS DADOS RECEBIDOS
        if ([ '', null, undefined ].indexOf(retornos.result) === -1) {
          dados = retornos.result
        }

        // ALTERA A MENSAGEM DO CAMPO
        dados.mensagem = mensagem

        // SETA OS DADOS RECEBIDOS DA PARCIAL
        this.upload = dados

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormImgArquivoLer: function (files, salvar = false, refId = null, callback = null) {
        if (files !== null) {
          // SETA OS ARQUIVOS RECEBIDOS
          for (var key in files) {
            if ([ '', null, undefined ].indexOf(files[key].name) === -1 && [ '', null, undefined ].indexOf(files[key].size) === -1) {
              this.arquivos[this.arquivos.length] = files[key]
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // VERIFICA SE DEVE FECHAR OU NÃO O FORMULARIO
          // if (([ '', null, undefined ].indexOf(this.cpntSalvarPosteriormente) === -1 && typeof this.cpntSalvarPosteriormente === 'function' && salvar === false)) {
          //   this.proFormImgLerArquivo(files)
          // } else {
          // }
          this.proFormImgArquivoLer(null, true, refId, callback)
        } else if (salvar === true && this.arquivos.length >= 1) {
          // OCULTA DE ARMAZENAMENTO
          this.mostrar = true

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // VERIFICA SE FOI RECEBIDO UM NOVO ID PARA SALVAR
          if ([ '', null, undefined ].indexOf(refId) !== -1) {
            refId = this.cpntRefId
          }

          // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
          const ARMAZENAR_ARQUIVO_S3 = require('@/assets/js/Armazenar-Arquivos.js').ARMAZENAR_ARQUIVO_S3
    
          // CHAMA A FUNÇÃO PARA ENVIAR O ARQUIVO
          ARMAZENAR_ARQUIVO_S3(this.arquivos, 12, Number(this.cpntId), this.proFormImgProgress).then((retorno) => {
            // TRATA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API({ lot: retorno }, null, 'API [200]: Arquivo(s) enviado(s) com sucesso.')  
    
            // LIMPA OS ARQUIVOS DO VETOR
            this.seletor.value = ''

            // LIMPA O VETOR DE ARQUIVOS
            this.arquivos = []

            // LIMPA O CAMPO
            this.upload = null

            // CHAMA A FUNÇÃO PARA BUSCAR AS IMAGENS DO PRODUTO
            this.proFormImgBuscarImagensProduto()

            // SETA A FUNÇÃO PARA VERIFICAR O SELETOR
            this.proFormImgVerificarStatusSeletor()
          }).catch(this.proFormImgSetarStatusGeral)
        }
      },
      proFormImgLerArquivo: function (files, index = 0, vetor = []) {
        if ([ '', null, undefined ].indexOf(files[index]) !== -1) {
          // OCULTA DE ARMAZENAMENTO
          this.mostrar = false

          // DESABILITA O INPUT PARA INSERIR NOVO
          this.seletor.disabled = false

          // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
          this.seletor.value = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else {
          // INICIA O VETOR
          vetor[index] = {}

          // SETA O ID DO ARQUIVO
          vetor[index].id = ''

          // SETA A EXTENSAO DO ARQUIVO
          vetor[index].ext = files[index].name.match(/\.[0-9a-z]+$/i)

          // SETA A EXTENSÃO DO ARQUIVO ENCONTRADA
          vetor[index].ext = vetor[index].ext.length === 1 ? vetor[index].ext[0].substring(1, vetor[index].ext[0].length) : vetor[index].ext[0]

          // CONVERTE A STRING PARA MINUSCULA
          vetor[index].ext = vetor[index].ext.toLowerCase()

          // SETA O NOME DO ARQUIVO
          vetor[index].name = files[index].name

          // VERIFICA O TIPO DE ARQUIVO
          switch (vetor[index].ext) {
            // SETA SE TEM ICONE DE IMAGEM
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
              vetor[index].size_bytes_thumbnail = Number(files[index].size)
              break

            // SETA QUE NÃO É UMA IMAGEM
            default:
              vetor[index].size_bytes_thumbnail = 0
              break
          }

          // INICIA A LEITURA DO ARQUIVO
          var reader = new FileReader()

          // SETA FUNÇÃO DE SUCESSO DE LEITURA
          reader.onload = () => {
            // INICIA A VARIAVEL
            var tagB64 = ''

            // VERIFICA SE DEVE COLOCAR OS DADOS DE BASE64 NO LINK
            if (vetor[index].size_bytes_thumbnail > 0) {
              tagB64 = 'data:image/' + vetor[index].ext + ';base64, '
            }

            // SETA A IMAGEM RECEBIDA
            vetor[index].thumbnail = tagB64 + (vetor[index].size_bytes_thumbnail === 0 ? '' : window.btoa(reader.result))
            vetor[index].conteudo = tagB64 + (window.btoa(reader.result))

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.proFormImgLerArquivo(files, (index + 1), vetor)
          }

          // FAZ A LEITURA DO ARQUIVO RECEBIDO
          reader.readAsBinaryString(files[index])
        }
      },
      proFormImgVerificarStatusSeletor: function () {
        // VERIFICA SE TEM ALGUM ARQUIVO SELECIONADO
        this.seletor.disabled = this.upload !== null
        
        // VERIFICA O STATUS DO CAMPO
        switch (this.seletor.disabled) {
          case true:
            // SETA A CLASSE DO CAMPO
            this.seletor.class = [ 'pro-form-img-box-upload', 'pro-form-img-box-upload-dragover' ]
            break

          case false:
            // SETA A CLASSE DO CAMPO
            this.seletor.class = [ 'pro-form-img-box-upload' ]
            break
        }

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.seletor.value = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormImgBuscarImagensProduto: function (callback = null, ids = []) {        
        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, filename: null, ext: null, size_bytes_thumbnail: null, posicao: null, last_at: null }, order: {} }

        // SETA O WHERE
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pro_imagem', o: '=', v: this.cpntId } ] }

        // BUSCA APENAS OS ARQUIVOS SOLICITADOS
        if (ids.length >= 1) {
          queryGet.where.aAnd.push({ f: 'id', o: 'in', v: ids.join() })
        }

        // PEGA APENAS ARQUIVOS QUE NÃO SÃO INTERNOS
        queryGet.where.aAnd.push({ f: 'interno', o: '=', v: 'n' })

        // SETA A ORDENAÇÃO
        queryGet.order = { posicao: 'asc', last_at: 'asc' }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, (apiSuccess) => {
          // PEGA OS DADOS RECEBIDOS
          var vetor = apiSuccess.data

          // INICIA O VETOR QUE VAI RECEBER OS DADOS
          var thumbnailIds = []
          
          for (var key in vetor) {
            // VERIFICA SE TEM ICONE
            if ([ '', null, undefined ].indexOf(vetor[key].size_bytes_thumbnail) === -1 && Number(vetor[key].size_bytes_thumbnail) > 0) {
              thumbnailIds.push(vetor[key].id)
            }

            // INICIA A VARIAVEL QUE VAI RECEBER O ICONE
            vetor[key].icone = ''
          }

          // CHAMA A FUNÇÃO PARA BUSCAR OS ICONES
          this.proFormImgBuscarThumbnail([ 'thumbnail_b64' ], thumbnailIds, (registros) => {
            if (registros.length >= 1) {
              for (var key in registros) {
                // PEGA O NUMERO DA LINHA
                var index = vetor.findIndex(item => item.id === registros[key].id)
  
                // VERIFICA SE FOI ENCONTADO O ICONE
                if (index !== -1) {
                  // JUNTA OS VALORES RECEBIDOS
                  vetor[index] = Object.assign(vetor[index], registros[key])
                  
                  // SETA O ICONE
                  vetor[index].thumbnail = registros[key].thumbnail_b64
                }
              }
  
              // SETA A PRIMEIRA IMAGEM A SER SELECIONADA
              this.currentId = vetor[0].id
  
              // ADICIONA OS ARQUIVOS RECEBIDOS
              this.items = vetor
            }

            // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS
            this.proFormImgAlterarPrincipal()

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()            

            // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
            if (callback !== null) {
              callback()
            }
          })
        }, this.proFormImgSetarStatusGeral)
      },
      proFormImgBuscarThumbnail: function (tipo, ids, callback, qtde = 300, ini = null, fim = null, retornos = []) {
        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null) {
          // PEGA OS IDS QUE DEVE BUSCAR
          var busca = ids.slice(ini, fim)
          
          // VERIFICA SE TEM QUE CONVERTER O
          if (typeof tipo === 'string') {
            tipo = [ tipo ]
          }

          // INICIA O QUERYGET
          var queryGet = { lot: [] }
          
          // ADICIONA O VALOR AO VETOR
          for (var key in busca) {
            queryGet.lot.push({ id: busca[key], tipo: tipo })
          }

          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, (apiSuccess) => {
            // ADICIONA OS VALORES NO VETOR
            for (var index in apiSuccess.lot) {
              switch (apiSuccess.lot[index].code) {
                case '200':
                  retornos.push(apiSuccess.lot[index].data)
                  break

                default:
                  this.$store.state.msgWarn('API [' + apiSuccess.lot[index].code + ']: ' + apiSuccess.lot[index].message, 'danger')
                  break
              }
            }

            // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
            this.proFormImgBuscarThumbnail(tipo, ids, callback, qtde, ini, fim, retornos)
          }, this.proFormImgSetarStatusGeral)
        } else if (callback !== null) {
          callback(retornos)
        }
      },
      proFormImgRemoverArquivo: function (id) {
        if (window.confirm('Deseja realmente enviar para a lixeira o arquivo selecionado?')) {
          // CRIA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = { j_id: [ id ] }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/arm-arquivo/lixeira', 'DELETE', formData, (apiSuccess) => {
            // TRATA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // VERIFICA SE DEU CERTO
            if (apiSuccess.lot[0].code === '200') {
              // REMOVE O ID SOLICITADO
              this.items = this.items.filter(item => item.id !== id)

              // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS
              this.proFormImgAlterarPrincipal()

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }, this.proFormImgSetarStatusGeral)
        } else {
          this.proFormImgBuscarImagensProduto()
        }
      },
      proFormImgAlterarPosicao: function (event) {
        // PEGA O ITEM QUE ESTÁ SENDO MODIFICADO
        var item = this.items[event.newIndex]

        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = {}

        // SETA O ID QUE DEVE ATUALIZAR
        formData.uuid = item.id

        // SETA POSIÇÃO A NOVA POSIÇÃO DA IMAGEM
        formData.posicao = Number(event.newIndex) + 1

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/arm-arquivo/posicao', 'PUT', formData, () => { this.proFormImgAlterarPrincipal() }, this.proFormImgSetarStatusGeral)
      },
      proFormImgAlterarPrincipal: function () {
        
        // PEGA O VALOR QUE DEVE TRABALHAR
        var dados = this.items.length >= 1 ? this.items[0] : null

        // SETA A ATUALIZAÇÃO DA IMAGEM
        if (dados !== null) {
          dados.time = new Date().getTime()
        }

        // SETA OS DADOS DA IMAGEM RECEBIDO
        this.$emit('ATUALIZAR_IMAGEM_PRODUTO', dados)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      // proFormImgCalcularTamanho: function (event) {
      //   // PEGA O ELEMENTO RECEBIDO
      //   var element = event.target

      //   // VERIFICA SE TEM UM VALOR VALIDO
      //   if ([ '', null, undefined ].indexOf(element) === -1) {
      //     // CARREGA OS VALORES
      //     var x = 95
      //     var y = 67
          
      //     // PEGA O TAMANHO DAS IMAGENS
      //     var imageWidth = element.width
      //     var imageHeight = element.height
          
      //     // CALCULA OS TAMANHOS PROPORCIONAIS
      //     if (imageHeight > y) {
      //       imageWidth = imageWidth * (y / imageHeight)
      //       imageHeight = y
    
      //       if (imageWidth > x) {
      //         imageHeight = imageHeight * (x / imageWidth)
      //         imageWidth = x
      //       }
      //     } else if (imageWidth > x) {
      //       imageHeight = imageHeight * (x / imageWidth)
      //       imageWidth = x
    
      //       if (imageHeight > y) {
      //         imageWidth = imageWidth * (y / imageHeight)
      //         imageHeight = y
      //       }
      //     }

      //     console.log(element, imageWidth, imageHeight)
          
      //     // SETA OS TAMANHOS CALCULADOS
      //     element.style.width = imageWidth
      //     element.style.height = imageHeight
      //   }
      // }
    }
  }
</script>
